import coverageJson from "./data/holdingsCoverage.generated.js";
import { normalizeIcpCanisterId } from "./icAgent.js";
import { ENTREPOT_PROXY } from "./constants.js";
function asFile(raw) {
    if (raw && typeof raw === "object" && "entries" in raw) {
        return raw;
    }
    return {
        version: 1,
        updatedAt: null,
        count: 0,
        tierCounts: { t0: 0, t1: 0, t2: 0 },
        sources: [],
        entries: [],
    };
}
const FILE = asFile(coverageJson);
export function getCoverageMeta() {
    return {
        updatedAt: FILE.updatedAt ?? null,
        count: FILE.count ?? FILE.entries.length,
        tierCounts: FILE.tierCounts ?? { t0: 0, t1: 0, t2: 0 },
        sources: FILE.sources ?? [],
    };
}
export function getCoverageEntries() {
    return FILE.entries ?? [];
}
/** Ordered canister IDs for a tier (deduped, normalized). */
export function getCoverageByTier(tier) {
    const out = [];
    const seen = new Set();
    for (const e of FILE.entries ?? []) {
        if (e.tier !== tier)
            continue;
        const id = normalizeIcpCanisterId(e.canisterId);
        if (!id || id === ENTREPOT_PROXY || seen.has(id))
            continue;
        seen.add(id);
        out.push(id);
    }
    return out;
}
/** Tier 0 DGDG + seed hot list. */
export function getDgdgHotCanisters() {
    const out = [];
    const seen = new Set();
    for (const e of FILE.entries ?? []) {
        if (e.tier !== 0)
            continue;
        if (!e.sources.includes("dgdg") && !e.standards.includes("ext")) {
            /* still include all tier0 EXT */
        }
        if (!e.standards.includes("ext") && e.standards.includes("icrc7"))
            continue;
        const id = normalizeIcpCanisterId(e.canisterId);
        if (!id || seen.has(id))
            continue;
        seen.add(id);
        out.push(id);
    }
    // Prefer dgdg-sourced first
    const dgdgFirst = (FILE.entries ?? [])
        .filter((e) => e.tier === 0 && e.sources.includes("dgdg"))
        .map((e) => normalizeIcpCanisterId(e.canisterId))
        .filter((id) => !!id);
    const rest = out.filter((id) => !dgdgFirst.includes(id));
    return [...new Set([...dgdgFirst, ...rest])];
}
/** Full ordered scan list: tier0 → tier1 → tier2, optionally promoting warm hits. */
export function getOrderedExtScanCanisters(options) {
    const maxTier = options?.maxTier ?? 2;
    const warm = new Set((options?.warmCanisters ?? [])
        .map((c) => normalizeIcpCanisterId(c))
        .filter((id) => !!id));
    const out = [];
    const seen = new Set();
    const push = (id) => {
        if (!id || id === ENTREPOT_PROXY || seen.has(id))
            return;
        seen.add(id);
        out.push(id);
    };
    // Warm hits first (session cache)
    for (const id of warm)
        push(id);
    for (let t = 0; t <= maxTier; t = (t + 1)) {
        for (const id of getCoverageByTier(t)) {
            const entry = FILE.entries.find((e) => e.canisterId === id);
            // Skip pure ICRC-7 seeds from EXT scan
            if (entry &&
                entry.standards.includes("icrc7") &&
                !entry.standards.includes("ext")) {
                continue;
            }
            push(id);
        }
    }
    return out;
}
